var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-layout"},[_c('div',{staticClass:"dashboard-root"},[_c('FixedBanner',{attrs:{"header":true}}),_vm._v(" "),_c('FixedBanner',{attrs:{"consent":true}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('FixedBanner',{attrs:{"footer":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }